import '../assets/css/m.css'
import '../assets/css/login.css'
import validate from '../assets/js/formvalidate'
import {showTip} from '../assets/js/formvalidate'

let baseUri =process.env.NODE_ENV === 'production'?'https://user.jxedt.com/':'//userjxedttest.58v5.cn/';
// baseUri='//userjxedttest.58v5.cn/';
function getCookie(c_name) {
    if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=")
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1
            c_end = document.cookie.indexOf(";", c_start)
            if (c_end == -1) c_end = document.cookie.length
            return unescape(document.cookie.substring(c_start, c_end))
        }
    }
    return ""
}
/**
 * 163 滑块验证初始化
 */
function init163() {
    initNECaptcha(
        {
            // config对象，参数配置
            captchaId: "e11978dc94fe431eb2ec9c510ddf97b9",
            element: "#captcha",
            mode: "popup",
            width: "280px",
            // 用户验证码验证成功后，进行实际的提交行为
            onVerify: function onVerify(err, data) {
                if (data) {
                    window.successToken = data.validate;
                    console.log('data',data)
                    getVerificationCode();
                }
            }
        },
        function onload(instance) {
            // 初始化成功后得到验证实例instance，可以调用实例的方法
            // console.log(instance);
            // self.l63inited = true;
            window.captchaIns = instance;
        },
        function onerror(err) {
            console.log("error", err);
            // self.l63inited = false;
            // 初始化失败后触发该函数，err对象描述当前错误信息
        }
    );
}
var code_msg = '获取验证码'
function getCode(phone) {
    if (!validate.valiphone()) {
        return false;
    } else if (code_msg !== "获取验证码") {
        showTip(
            code_msg,
            3000
        );
        return;
    }

    window.captchaIns && window.captchaIns.refresh();
    window.captchaIns && window.captchaIns.popUp();
}
/**
* 登录
*/
function loginIn(phone, phone_code) {
    var r_id = window.r_id;
    let self = this;
    // baseUri = 'http://10.252.246.19:8080/'
console.log('loginIn')
    $.ajax({
        dataType: "json",
        type: "post",
        url:baseUri+ "m/login",
        data: {
            successToken: window.successToken,
            phonerid: r_id,
            isMsg: false,
            phone: phone,
            password: "",
            indexccode: phone_code
        },
        xhrFields: {
            withCredentials: true
        },
        crossDomain: true,
        success: function success(res) {

            window.loading = false;
            if (res.code == 0) {
                window.successToken = null;
                //登陆成功
                // self.show_login=false;
                window.clearInterval(window.timer);
                code_msg = "获取验证码";
                showTip("登录成功",
                    1000
                );
                var jumpurl = '/';
                if (typeof res.jumpUrl != 'undefined' && res.jumpUrl != '') {
                    jumpurl = decodeURIComponent(res.jumpUrl);
                }
                window.location.href = jumpurl;
            } else {
                window.loading = false;
                showTip(res.msg,
                    1000
                );
            }
        },
        error: function error(res) {
            // self.loading = false;
            showTip("登录异常，请联系管理员",
                4000
            );
        }
    });
}

/** 获取验证码
 * @param {} phone 手机号
 * @param {} el 获取验证码按钮
 */
function getVerificationCode(phone) {
    phone = $('input[name="telephone"]').val();

    var d = new Date();
    var time = d.getTime();
    let self = this;
    // self.isSendCode = false;
    var n = 60;
    // window.clearInterval(window.timer);
    window.timer = window.setInterval(function () {
        if (n <= 1) {
            // self.isSendCode = true;
            window.clearInterval(window.timer);
            code_msg = "获取验证码";
            $('#but02').addClass('clickable').text(code_msg)
        } else {
            code_msg = --n + " 秒后重试";
            $('#but02').removeClass('clickable').text(code_msg)
        }
    }, 1000);

    //user.jxedt.com
    $.ajax({
        dataType: "json",
        type: "get",
        url: baseUri+"/captcha/pcSendCode",
        // url: "https://user.jxedt.com/captcha/pcSendCode",
        data: {
            t: 1,
            m: 1,
            p: 3,
            mobile: phone,
            successToken: window.successToken,
            _: time
        },
        success: function success(res) {
            console.log("res", res);
            if (res.code != 0) {

                window.clearInterval(window.timer);
                n = 60;
                showTip(res.msg,
                    2000
                );
            } else {
                code_msg = "获取验证码";
                $('#but02').addClass('clickable').text(code_msg)
                window.r_id = res.result.rid;
                showTip("验证码发送成功",
                    2000
                );
            }
        },
        error: function (res) {
            console.log("error", res);
        }
    });
}

$(function () {
    init163()
    var flag = true;
    $('.input').on("click", "#but02", function () {
        var tel = $('input[name="telephone"]').val();
        getCode(tel)
        
    });

    inithit({
        'cate': 'NA',
        'area': 'NA',
        'pagetype': 'password',
        'page': 'login'
    });
    /**
     * 已经阅读了协议的点击事件
     */
    $("i.icon_xuanzhong").on("click", function () {
        if ($(this).hasClass("checked")) {
            $(this).removeClass('checked')
        } else {
            $(this).addClass('checked')
            if ($(this).hasClass('code')) {
                checkSubmitCode();
            } else {
                checkSubmit();
            }
        }
    })

    function checkSubmitCode() {
        if (!validate.checkSubmitCode(true)) {
            $("#login_code").addClass('clickable')
        } else {
            $("#login_code").removeClass('clickable')
        }
    }
   /**
     * 账号密码输入过程中要判断是否能点击提交按钮
     */
    $("input#telephone").on('input', function () {
        if(validate.valiphone(true)){
           $('.phone_code').addClass('clickable');
        }else{
            $('.phone_code').removeClass('clickable');

        }
        checkSubmitCode()
    })

    /**
     * 账号密码输入过程中要判断是否能点击提交按钮
     */
    $("input#phone_code").on('input', function () {
        checkSubmitCode()
    })

    /**
     * 密码显示隐藏图标的点击事件
     */
    $("i.icon_xianshi").on("click", function () {
        if ($(this).hasClass("checked")) {
            $(this).removeClass('checked')
            $("#password").attr("type", "password")

        } else {
            $(this).addClass('checked')
            $("#password").attr("type", "text")
        }
    })
 
    /**
     * 验证码登陆提交按钮事件
     */
    $("#login_code").on("click", function () {
        if (validate.checkSubmitCode()) {
            return false
        } else {
            loginIn($("#telephone").val(),$("#phone_code").val());
        }
    });
})







// WEBPACK FOOTER //
// ./src/login_code/index.js